import { createRoot } from 'react-dom/client';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import '@/assets/css/loading.scss';

let loadingRoot = null;

export function showLoading({ targetDom } = {}) {
  if (document.getElementById('loadingDom')) {
    return false;
  }

  const loadDom = document.createElement('div');

  loadDom.setAttribute('id', 'loadingDom');

  if (targetDom) {
    targetDom.appendChild(loadDom);
  } else {
    document.body.appendChild(loadDom);
  }

  const antIcon = <LoadingOutlined spin />;

  // Use React 18's createRoot API
  loadingRoot = createRoot(loadDom);
  loadingRoot.render(<Spin indicator={antIcon} />);
}

export function hideLoading({ targetDom } = {}) {
  if (!document.getElementById('loadingDom')) {
    return false;
  }

  const loadDom = document.getElementById('loadingDom');

  if (loadDom) {
    // Unmount React 18 root before removing DOM element
    if (loadingRoot) {
      loadingRoot.unmount();
      loadingRoot = null;
    }

    if (targetDom) {
      targetDom.removeChild(loadDom);
    } else {
      document.body.removeChild(loadDom);
    }
  }
}

export default () => <></>;
